import React from 'react';
import { AlertTriangle, AlertCircle, Info, ShieldAlert } from 'lucide-react';
import { FindingSeverity } from '../../types/finding';
import { Badge } from '../../design-system';
import { SEVERITY_TONE, SEVERITY_LABEL } from '../../design-system/severity';

interface FindingSeverityBadgeProps {
  severity: FindingSeverity;
  showLabel?: boolean;
}

const ICON: Record<FindingSeverity, React.ElementType> = {
  critical: ShieldAlert,
  high: AlertCircle,
  medium: AlertTriangle,
  low: Info,
};

/** Severity pill (icon + label) — colours come from the design-system Badge tones. */
const FindingSeverityBadge: React.FC<FindingSeverityBadgeProps> = ({ severity, showLabel = true }) => {
  const Icon = ICON[severity] || AlertTriangle;
  return (
    <Badge tone={SEVERITY_TONE[severity]} size="md" icon={<Icon className="w-3.5 h-3.5" />}>
      {showLabel ? SEVERITY_LABEL[severity] : null}
    </Badge>
  );
};

export default FindingSeverityBadge;
